/**
 * Thrown by the authenticated fetch layer when a valid access token could not be
 * obtained, so the request is NOT sent unauthenticated (which would produce a
 * server 401 and a scattered "Unauthorized." panel).
 */

/** The session is definitively dead and could not be silently recovered. The
 *  app-wide SessionExpiredBanner is the single recovery UI, so per-panel errors
 *  of this type are suppressed and the query is not retried. */
export class SessionExpiredError extends Error {
    constructor() {
        super('Your session has expired.');
        this.name = 'SessionExpiredError';
    }
}

/** A token is temporarily unavailable (transient refresh failure, or a session
 *  not yet exchanged). Safe to retry — the query layer will re-attempt. */
export class AuthUnavailableError extends Error {
    constructor() {
        super('Authentication is temporarily unavailable.');
        this.name = 'AuthUnavailableError';
    }
}

export function isSessionExpiredError(err: unknown): boolean {
    return err instanceof SessionExpiredError;
}

export function isAuthUnavailableError(err: unknown): boolean {
    return err instanceof AuthUnavailableError;
}
